// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export interface RichTextNode<T = any> {
  type: string;
  text?: string;
  content?: T[];
}

export function isRichTextEmpty<T extends RichTextNode<T>>(data?: {
  content?: T[];
}): boolean {
  if (!data?.content || data.content.length === 0) return true;

  function isNodeEmpty(node: T): boolean {
    if (node.type === "text") {
      return !node.text?.trim();
    }

    if (node.type === "blok") {
      return false;
    }

    if (Array.isArray(node.content)) {
      return node.content.every(isNodeEmpty);
    }

    return true;
  }

  return data.content.every(isNodeEmpty);
}
